<div class="common-view-container" [class.read-only-mode]="readOnly">
    <div class="card-accent"></div>

    <div class="view-header">
        <div class="title-wrapper" style="display: flex; align-items: center; gap: 8px;
        margin-bottom: 5px;">
            <span *ngIf="image || emoji" style="display: flex; align-items: center;">
                <img *ngIf="image" [src]="image" style="width: 20px; height: 20px; object-fit: cover;">
                <span *ngIf="!image">{{ emoji }}</span>
            </span>
            <h3>{{ title }}</h3>
        </div>

        <div class="actions" *ngIf="!readOnly">
            <button nz-button nzType="text" nzShape="circle" (click)="onEdit.emit()" nz-tooltip nzTooltipTitle="Edit">
                <i nz-icon nzType="edit" nzTheme="outline"></i>
            </button>
            <button nz-button nzType="text" nzDanger nzShape="circle" nz-popconfirm
                [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'" [nzPopconfirmTitle]="popconfirmTpl"
                nzPopconfirmPlacement="bottomRight" (nzOnConfirm)="onDelete.emit()" nz-tooltip nzTooltipTitle="Delete">
                <i nz-icon nzType="delete" nzTheme="outline"></i>
            </button>
        </div>
    </div>

    <div class="view-content">
        <div nz-row [nzGutter]="[24, 24]" [class.venue-overview-grid]="isVenueOverview">
            <div nz-col [nzSpan]="isVenueOverview ? 24 : (field.fullWidth ? 24 : 12)"
                *ngFor="let field of mainConfig; let i = index">
                <div class="field-item" *ngIf="shouldShowField(data, field)">
                    <label><span class="label-text">{{ field.label }}</span></label>
                    <div class="value">
                        <ng-container *ngIf="getFormattedValue(data, field) as val">
                            <span *ngIf="val.length <= 150">{{ val }}</span>
                            <span *ngIf="val.length > 150">
                                {{ val | slice:0:150 }}...
                                <a (click)="showFullContent(field.label, val)">View More</a>
                            </span>
                        </ng-container>
                    </div>
                </div>

                <div class="field-item group-array-field" *ngIf="field.type === 'group-array' && getGroupItems(data, field).length">
                    <label>{{ field.label }}</label>
                    <div class="group-array-list">
                        <div class="group-array-item" *ngFor="let group of getGroupItems(data, field); let gi = index">
                            <span class="group-array-item-index">{{ gi + 1 }}</span>
                            <div class="group-array-item-fields">
                                <div class="group-sub-field" *ngFor="let sub of field.groupFields">
                                    <span class="group-sub-label">{{ sub.label }}</span>
                                    <span class="group-sub-value">{{ getGroupFieldValue(group, sub) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ng-container *ngIf="field.key === 'audio_equipment_details'">
                    <div *ngIf="data?.audio_requirements_note" class="note-section full-width">
                        <span class="note-label"><i nz-icon nzType="sound" nzTheme="outline"></i> Audio Note</span>
                        <p>
                            <ng-container *ngIf="data.audio_requirements_note as val">
                                <span *ngIf="val.length <= 150">{{ val }}</span>
                                <span *ngIf="val.length > 150">
                                    {{ val | slice:0:150 }}...
                                    <a (click)="showFullContent('Audio Note', val)">View More</a>
                                </span>
                            </ng-container>
                        </p>
                    </div>
                </ng-container>

                <ng-container *ngIf="field.key === 'cameras_recording_details'">
                    <div *ngIf="data?.video_requirements_note" class="note-section full-width">
                        <span class="note-label"><i nz-icon nzType="video-camera" nzTheme="outline"></i> Video
                            Note</span>
                        <p>
                            <ng-container *ngIf="data.video_requirements_note as val">
                                <span *ngIf="val.length <= 150">{{ val }}</span>
                                <span *ngIf="val.length > 150">
                                    {{ val | slice:0:150 }}...
                                    <a (click)="showFullContent('Video Note', val)">View More</a>
                                </span>
                            </ng-container>
                        </p>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="legacy-section" *ngIf="legacyConfig.length">
            <div class="legacy-section-header">
                <span class="legacy-badge">Legacy</span>
                <span class="legacy-section-title">Carried over from the previous single-venue format</span>
            </div>
            <div nz-row [nzGutter]="[24, 24]">
                <div nz-col [nzSpan]="field.fullWidth ? 24 : 12" *ngFor="let field of legacyConfig">
                    <div class="field-item" *ngIf="shouldShowField(data, field)">
                        <label><span class="label-text">{{ field.label }}</span></label>
                        <div class="value">
                            <ng-container *ngIf="getFormattedValue(data, field) as val">
                                <span *ngIf="val.length <= 150">{{ val }}</span>
                                <span *ngIf="val.length > 150">
                                    {{ val | slice:0:150 }}...
                                    <a (click)="showFullContent(field.label, val)">View More</a>
                                </span>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="data?.lighting_requirements_note && !isLightingNoteInConfig()" class="note-section lighting-note">
            <span class="note-label"><i nz-icon nzType="bulb" nzTheme="outline"></i> Lighting Note</span>
            <p>
                <ng-container *ngIf="data.lighting_requirements_note as val">
                    <span *ngIf="val.length <= 150">{{ val }}</span>
                    <span *ngIf="val.length > 150">
                        {{ val | slice:0:150 }}...
                        <a (click)="showFullContent('Lighting Note', val)">View More</a>
                    </span>
                </ng-container>
            </p>
        </div>
    </div>
</div>

<!-- Only show in view mode if modal is requested -->
<nz-modal [(nzVisible)]="isModalVisible" [nzTitle]="modalTitle" (nzOnCancel)="handleCancel()" [nzFooter]="null">
    <ng-container *nzModalContent>
        <p style="white-space: pre-wrap;">{{ modalContent }}</p>
    </ng-container>
</nz-modal>

<ng-template #popconfirmTpl let-popconfirm="popconfirm">
    <div class="custom-popconfirm-header">
        <span class="custom-popconfirm-title">
            Confirm Deletion
        </span>
    </div>
    <div class="custom-popconfirm-icon-area">
        <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
            <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
        </span>
    </div>
    <div class="custom-popconfirm-message description">
        Are you sure you want to delete this item?<br />
        <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
    </div>
</ng-template>